import { render, staticRenderFns } from "./helpactivity.vue?vue&type=template&id=2e96b472&scoped=true"
import script from "./helpactivity.vue?vue&type=script&lang=ts"
export * from "./helpactivity.vue?vue&type=script&lang=ts"
import style0 from "./helpactivity.vue?vue&type=style&index=0&id=2e96b472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96b472",
  null
  
)

export default component.exports